import { ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // Custom font sizes
      'font-size': [
        {
          text: ['us', 'smLabel'],
        },
      ],
      // Custom screen breakpoints for responsive design
      display: [
        {
          '3xl:': [],
          '4xl:': [],
          '5xl:': [],
        },
      ],
      // Custom colors (theme palette)
      'bg-color': [
        // Primary colors
        { bg: ['theme-primary-0'] },
        { bg: ['theme-primary-10'] },
        { bg: ['theme-primary-20'] },
        { bg: ['theme-primary-30'] },
        { bg: ['theme-primary-40'] },
        { bg: ['theme-primary-50'] },
        { bg: ['theme-primary-60'] },
        { bg: ['theme-primary-70'] },
        { bg: ['theme-primary-80'] },
        { bg: ['theme-primary-90'] },
        { bg: ['theme-primary-95'] },
        { bg: ['theme-primary-99'] },
        { bg: ['theme-primary-100'] },
        { bg: ['theme-primary-main'] },
        { bg: ['theme-primary-dark'] },
        { bg: ['theme-primary-light'] },
        { bg: ['theme-primary-linear'] },
        { bg: ['theme-primary-disabled'] },
        { bg: ['theme-primary-transparent'] },

        // Neutral colors
        { bg: ['theme-neutral-0'] },
        { bg: ['theme-neutral-10'] },
        { bg: ['theme-neutral-20'] },
        { bg: ['theme-neutral-30'] },
        { bg: ['theme-neutral-40'] },
        { bg: ['theme-neutral-50'] },
        { bg: ['theme-neutral-60'] },
        { bg: ['theme-neutral-70'] },
        { bg: ['theme-neutral-80'] },
        { bg: ['theme-neutral-90'] },
        { bg: ['theme-neutral-95'] },
        { bg: ['theme-neutral-99'] },
        { bg: ['theme-neutral-100'] },
        { bg: ['theme-neutral-main'] },
        { bg: ['theme-neutral-dark'] },
        { bg: ['theme-neutral-light'] },
        { bg: ['theme-neutral-text'] },

        // Neutral variant colors
        { bg: ['theme-neutralVariant-0'] },
        { bg: ['theme-neutralVariant-10'] },
        { bg: ['theme-neutralVariant-20'] },
        { bg: ['theme-neutralVariant-30'] },
        { bg: ['theme-neutralVariant-40'] },
        { bg: ['theme-neutralVariant-50'] },
        { bg: ['theme-neutralVariant-60'] },
        { bg: ['theme-neutralVariant-70'] },
        { bg: ['theme-neutralVariant-80'] },
        { bg: ['theme-neutralVariant-90'] },
        { bg: ['theme-neutralVariant-95'] },
        { bg: ['theme-neutralVariant-99'] },
        { bg: ['theme-neutralVariant-100'] },
        { bg: ['theme-neutralVariant-main'] },
        { bg: ['theme-neutralVariant-dark'] },
        { bg: ['theme-neutralVariant-light'] },

        // Error colors
        { bg: ['theme-error-0'] },
        { bg: ['theme-error-10'] },
        { bg: ['theme-error-20'] },
        { bg: ['theme-error-30'] },
        { bg: ['theme-error-40'] },
        { bg: ['theme-error-50'] },
        { bg: ['theme-error-60'] },
        { bg: ['theme-error-70'] },
        { bg: ['theme-error-80'] },
        { bg: ['theme-error-90'] },
        { bg: ['theme-error-95'] },
        { bg: ['theme-error-99'] },
        { bg: ['theme-error-100'] },
        { bg: ['theme-error-main'] },
        { bg: ['theme-error-dark'] },
        { bg: ['theme-error-light'] },

        // Background colors
        { bg: ['theme-background-default'] },
        { bg: ['theme-background-light'] },
        { bg: ['theme-background-main'] },

        // Surface colors
        { bg: ['theme-surface-default'] },
        { bg: ['theme-surface-dark'] },
        { bg: ['theme-surface-lightBlue'] },
        { bg: ['theme-surface-gray'] },
        { bg: ['theme-surface-white'] },

        // Border colors
        { bg: ['theme-border-default'] },
        { bg: ['theme-border-main'] },

        // Icon colors
        { bg: ['theme-icon-main'] },
        { bg: ['theme-icon-dark'] },
        { bg: ['theme-icon-lightBlue'] },
        { bg: ['theme-icon-shadeBlue'] },

        // Text colors
        { bg: ['theme-text-black'] },
        { bg: ['theme-text-white'] },
        { bg: ['theme-text-primary'] },
        { bg: ['theme-text-main'] },
        { bg: ['theme-text-secondary'] },
        { bg: ['theme-text-title'] },
        { bg: ['theme-text-darker'] },
        { bg: ['theme-text-disabled'] },

        // Misc colors
        { bg: ['theme-scrollbarThumb'] },
        { bg: ['theme-scrollbarThumbHover'] },
        { bg: ['theme-scrollbarThumbActive'] },
        { bg: ['theme-tippyWhite'] },
        { bg: ['theme-tippyBlack'] },
      ],
      'text-color': [
        // Primary colors
        { text: ['theme-primary-0'] },
        { text: ['theme-primary-10'] },
        { text: ['theme-primary-20'] },
        { text: ['theme-primary-30'] },
        { text: ['theme-primary-40'] },
        { text: ['theme-primary-50'] },
        { text: ['theme-primary-60'] },
        { text: ['theme-primary-70'] },
        { text: ['theme-primary-80'] },
        { text: ['theme-primary-90'] },
        { text: ['theme-primary-95'] },
        { text: ['theme-primary-99'] },
        { text: ['theme-primary-100'] },
        { text: ['theme-primary-main'] },
        { text: ['theme-primary-dark'] },
        { text: ['theme-primary-light'] },
        { text: ['theme-primary-linear'] },
        { text: ['theme-primary-disabled'] },
        { text: ['theme-primary-transparent'] },

        // Neutral colors
        { text: ['theme-neutral-0'] },
        { text: ['theme-neutral-10'] },
        { text: ['theme-neutral-20'] },
        { text: ['theme-neutral-30'] },
        { text: ['theme-neutral-40'] },
        { text: ['theme-neutral-50'] },
        { text: ['theme-neutral-60'] },
        { text: ['theme-neutral-70'] },
        { text: ['theme-neutral-80'] },
        { text: ['theme-neutral-90'] },
        { text: ['theme-neutral-95'] },
        { text: ['theme-neutral-99'] },
        { text: ['theme-neutral-100'] },
        { text: ['theme-neutral-main'] },
        { text: ['theme-neutral-dark'] },
        { text: ['theme-neutral-light'] },
        { text: ['theme-neutral-text'] },

        // Neutral variant colors
        { text: ['theme-neutralVariant-0'] },
        { text: ['theme-neutralVariant-10'] },
        { text: ['theme-neutralVariant-20'] },
        { text: ['theme-neutralVariant-30'] },
        { text: ['theme-neutralVariant-40'] },
        { text: ['theme-neutralVariant-50'] },
        { text: ['theme-neutralVariant-60'] },
        { text: ['theme-neutralVariant-70'] },
        { text: ['theme-neutralVariant-80'] },
        { text: ['theme-neutralVariant-90'] },
        { text: ['theme-neutralVariant-95'] },
        { text: ['theme-neutralVariant-99'] },
        { text: ['theme-neutralVariant-100'] },
        { text: ['theme-neutralVariant-main'] },
        { text: ['theme-neutralVariant-dark'] },
        { text: ['theme-neutralVariant-light'] },

        // Error colors
        { text: ['theme-error-0'] },
        { text: ['theme-error-10'] },
        { text: ['theme-error-20'] },
        { text: ['theme-error-30'] },
        { text: ['theme-error-40'] },
        { text: ['theme-error-50'] },
        { text: ['theme-error-60'] },
        { text: ['theme-error-70'] },
        { text: ['theme-error-80'] },
        { text: ['theme-error-90'] },
        { text: ['theme-error-95'] },
        { text: ['theme-error-99'] },
        { text: ['theme-error-100'] },
        { text: ['theme-error-main'] },
        { text: ['theme-error-dark'] },
        { text: ['theme-error-light'] },

        // Text colors
        { text: ['theme-text-black'] },
        { text: ['theme-text-white'] },
        { text: ['theme-text-primary'] },
        { text: ['theme-text-main'] },
        { text: ['theme-text-secondary'] },
        { text: ['theme-text-title'] },
        { text: ['theme-text-darker'] },
        { text: ['theme-text-disabled'] },

        // Misc colors
        { text: ['theme-scrollbarThumb'] },
        { text: ['theme-scrollbarThumbHover'] },
        { text: ['theme-scrollbarThumbActive'] },
        { text: ['theme-tippyWhite'] },
        { text: ['theme-tippyBlack'] },
      ],
      'border-color': [
        // Primary colors
        { border: ['theme-primary-0'] },
        { border: ['theme-primary-10'] },
        { border: ['theme-primary-20'] },
        { border: ['theme-primary-30'] },
        { border: ['theme-primary-40'] },
        { border: ['theme-primary-50'] },
        { border: ['theme-primary-60'] },
        { border: ['theme-primary-70'] },
        { border: ['theme-primary-80'] },
        { border: ['theme-primary-90'] },
        { border: ['theme-primary-95'] },
        { border: ['theme-primary-99'] },
        { border: ['theme-primary-100'] },
        { border: ['theme-primary-main'] },
        { border: ['theme-primary-dark'] },
        { border: ['theme-primary-light'] },
        { border: ['theme-primary-transparent'] },

        // Border specific colors
        { border: ['theme-border-default'] },
        { border: ['theme-border-main'] },

        // Error colors for borders
        { border: ['theme-error-main'] },
        { border: ['theme-error-dark'] },
        { border: ['theme-error-light'] },
      ],
      // Custom max width
      'max-w': [
        // Add custom max width
        { max: ['screen'] },
      ],
      // Custom shadows
      shadow: [
        {
          shadow: ['card', 'glow'],
        },
      ],
      // Custom animations
      animate: [
        {
          animate: ['spin-gradual', 'shimmer'],
        },
      ],
      // Custom scale values
      scale: [
        {
          scale: ['-100'],
        },
      ],
      // Custom utilities
      content: [
        { 'ellipsis-text': ['ellipsis-text'] },
        { 'hidden-scrollbar': ['hidden-scrollbar'] },
        { 'padded-scrollbar-track': ['padded-scrollbar-track'] },
        { 'padded-horizontal-scrollbar-track': ['padded-horizontal-scrollbar-track'] },
      ],
    },
    theme: {},
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
